/* @flow */

import React from 'react';
import glamorous from 'glamorous';
import { padding } from 'polished';
import HowToPlayButton from './HowToPlayButton';

type Props = {
  onClick: number => void,
  steps: Array<Object>,
};

const List = glamorous.ul(props => ({
  display: 'flex',
  flexDirection: 'column',
  fontWeight: props.theme.fontWeight.normal,
  justifyContent: 'center',
  listStyle: 'none',
  margin: 0,
  padding: 0,
  textTransform: 'uppercase',

  [props.theme.mediaQuery.desktopAndUp]: {
    flexDirection: 'row',
    fontSize: props.theme.fontSize.xxsmall,
    ...padding('2rem', null),
  },

  [props.theme.mediaQuery.desktopLargeOnly]: {
    fontSize: props.theme.fontSize.default,
  },
}));

const Item = glamorous.li(props => ({
  alignItems: 'stretch',
  display: 'flex',

  [props.theme.mediaQuery.desktopAndUp]: {
    flexBasis: '15rem',
    flexDirection: 'row',
    flexGrow: 0,
    flexShrink: 1,
    ...padding('0.5em', '0.25em'),
  },

  [props.theme.mediaQuery.desktopLargeOnly]: {
    flexBasis: '16rem',
    ...padding(null, '0.375em'),
  },
}));

function HowToPlaySteps({ onClick, steps }: Props) {
  return (
    <List>
      {steps.map((step, i) => (
        <Item
          key={i} // eslint-disable-line react/no-array-index-key
        >
          <HowToPlayButton onClick={() => onClick(i)} title={step.title} />
        </Item>
      ))}
    </List>
  );
}

export default HowToPlaySteps;
